import APIcon, { APIconName } from "../APIcon";
import APOutlineButton from "./APOutlineButton";

const InfoOutlineButton = ({
  text,
  onClick,
  iconOverride,
}: {
  text: string;
  onClick?: () => void;
  iconOverride?: APIconName;
}) => {
  return (
    <APOutlineButton
      text={text}
      onClick={onClick}
      color="primary"
      startAdornment={
        <APIcon name={iconOverride ?? "lightbulb"} color="primary" />
      }
    />
  );
};

export default InfoOutlineButton;
